<template>
    <employment-doc-view
        v-bind="{
            contract: form,
            value: fields,
            pages,
            mode,
        }"
        ref="employment-doc-view"
    />
</template>

<script>
import { initEmploymentContract } from "@/assets/variables";

import EmploymentDocView from "@/components/console/employment/doc/employment-doc-view.vue";

export default {
    components: {
        EmploymentDocView,
    },
    props: {
        /** @type {import('vue').PropType<'form'|'sign'|'view'|'done''>} */
        mode: { type: String, default: "done" },

        /** @type {import('vue').PropType<import('@/assets/variables').EmploymentContract>} */
        value: { type: Object, default: initEmploymentContract },
    },
    data: () => ({
        form: initEmploymentContract(),
    }),
    computed: {
        pages() {
            return this.form?.form?.pages || [];
        },
        fields() {
            return [...this.form.fields_document, ...this.form.fields_employee];
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initEmploymentContract(this.value);
        },
    },
};
</script>

<style></style>
